import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const StyledMember = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 4% -8%,
      rgba(99, 102, 241, 0.14) 0%,
      transparent 35%
    ),
    radial-gradient(
      circle at 98% 108%,
      rgba(14, 165, 233, 0.12) 0%,
      transparent 42%
    ),
    var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .detail-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 16px;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 14px;
  }

  .content-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }
`

const StyledMemberDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .detail-shell {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    overflow: hidden;
  }

  .detail-tabs {
    border-bottom: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
  }

  .detail-tabs .MuiTabs-root {
    min-height: 48px;
  }

  .detail-tabs .MuiTab-root {
    text-transform: none;
    font-weight: 700;
    min-height: 48px;
  }

  .tab-panel {
    padding: 16px;
  }

  .header-bar {
    display: flex;
    flex-direction: row;
  }
`

const StyledMemberInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .member-overview-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    box-shadow: none;
    background: var(--cms-surface-secondary);
  }

  .member-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .member-field {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-muted);
    padding: 10px 12px;
  }

  .field-label {
    font-size: 12px;
    font-weight: 700;
    color: var(--cms-text-secondary);
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .field-value {
    font-size: 14px;
    color: var(--cms-text-primary);
    font-weight: 600;
    word-break: break-word;
  }

  .section-block {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-secondary);
    padding: 12px;
  }

  .section-title {
    font-size: 13px;
    font-weight: 800;
    color: var(--cms-text-primary);
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .meta-text {
    margin: 0 0 8px;
    color: var(--cms-text-primary);
    font-size: 13px;
    line-height: 1.5;
  }

  .switch-note {
    font-size: 12px;
    color: var(--cms-text-secondary);
    margin-top: -4px;
    margin-bottom: 10px;
  }

  .badge-chip-stack {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .save-badges-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 36px;
    padding: 5px 12px;
  }

  .review {
  }

  @media (max-width: 900px) {
    .member-grid {
      grid-template-columns: minmax(0, 1fr);
    }
  }
`

const StyledMemberReviews = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;

  .review-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .review-card .MuiCardContent-root {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .review {
    display: flex;
    flex-direction: column;
    height: 100%;

    .review-content {
      max-height: 220px;
      overflow-y: auto;
      line-height: 1.5;
      color: var(--cms-text-primary);
      white-space: pre-wrap;
    }
    .MuiCircularProgress-root {
      width: 20px !important;
      height: 20px !important;
    }
  }
  .card {
    width: 100%;
    margin-right: 0;
    height: 100%;
  }

  .review-rate {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 700;
    svg {
      width: 15px;
      path {
        fill: #e59819;
      }
    }
  }
  .review-time {
    font-size: 12px;
    margin: 0;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .review-actions {
    margin-top: auto;
    padding: 8px 16px 14px;
  }

  .review-actions .MuiButton-root {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 34px;
  }

  .reviews-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    grid-column: 1 / -1;
  }
`

const StyledMemberSearch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const StyledMemberSearchBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--cms-border);
  background: var(--cms-surface-secondary);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);

  .filter-name {
    width: 220px;
  }

  .filter-email {
    width: 240px;
  }

  .filter-sm {
    width: 140px;
  }

  .filter-md {
    width: 160px;
  }

  .MuiInputBase-root {
    border-radius: 10px;
    background: var(--cms-input-bg);
  }

  .search-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-left: auto;
  }

  .search-btn {
    text-transform: none;
    border-radius: 9px;
    min-height: 38px;
    font-weight: 700;
    padding: 6px 12px;
  }

  @media (max-width: 1180px) {
    .search-actions {
      width: 100%;
      justify-content: flex-end;
    }
  }
`

const StyledMemberTable = styled.div`
  .table-shell .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .table-shell .MuiTableCell-head {
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .table-shell .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .row-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .row-actions .MuiButton-root {
    text-transform: none;
    border-radius: 9px;
    min-height: 34px;
    font-weight: 700;
    padding: 4px 10px;
  }

  .pagination-section {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
  }

  .search-result-info {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-secondary);
    padding: 10px 12px;
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 16px;
  }

  .permission-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 20px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }
`

const StyledMemberSubscriptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .section-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    box-shadow: none;
    background: var(--cms-surface-secondary);
  }

  .section-title {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .section-subtitle {
    margin: 0 0 10px;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .action-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .action-toolbar .MuiButton-root,
  .button-block .MuiButton-root {
    text-transform: none;
    border-radius: 9px;
    min-height: 36px;
    font-weight: 700;
    padding: 5px 12px;
  }

  .button-block {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .can-btn {
    padding: 7px 18px !important;
    margin: 10px 0 0;
  }

  .danger-note {
    border: 1px solid #fecaca;
    border-radius: 10px;
    background: #fff1f2;
    color: #7f1d1d;
    padding: 12px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 12px;
  }

  .account-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .account-item {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-muted);
    padding: 10px 12px;
  }

  .account-label {
    font-size: 12px;
    font-weight: 700;
    color: var(--cms-text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 5px;
  }

  .account-value {
    color: var(--cms-text-primary);
    font-size: 14px;
    font-weight: 600;
    word-break: break-word;
  }

  .access-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 10px;
  }

  .access-item {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-muted);
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .access-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
  }

  .access-meta {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
  }

  .program-detail-box {
    border: 1px solid var(--cms-border);
    border-radius: 9px;
    background: var(--cms-surface-secondary);
    padding: 8px 10px;
  }

  .program-detail-title {
    margin: 0 0 8px;
    font-size: 12px;
    color: var(--cms-text-primary);
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .program-detail-item {
    margin: 0 0 6px;
    font-size: 13px;
    color: var(--cms-text-primary);
    line-height: 1.45;
  }

  .reset-password-form {
    max-width: 420px;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .MuiFormControl-root {
      margin-bottom: 0;
    }
  }

  .community-toggle {
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-muted);
    padding: 8px 10px;
    margin-top: 10px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  @media (max-width: 860px) {
    .account-row {
      grid-template-columns: minmax(0, 1fr);
    }
  }
`

const StyledModalMemberPasswordResetDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(620px, calc(100vw - 28px));
    max-width: none;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .dialog-close-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .error {
    font-size: 0.75rem;
    color: #d32f2f;
    margin-top: 3px;
  }

  .MuiDialogContent-root {
    form {
      margin: 0 !important;
      display: flex;
      flex-direction: column;
      gap: 10px;

      button {
        margin-top: 0;
      }
    }
  }
`

const StyledMemberHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  font-weight: 300;

  .history-shell .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .history-shell .MuiTableCell-head {
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .history-shell .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .email-history {
    margin: 15px 0;
  }

  .table-heading {
    font-size: 18px;
    font-weight: 800;
    color: var(--cms-text-primary);
    padding: 14px 14px 4px;
    letter-spacing: -0.01em;
  }

  .pagination-section {
    display: flex;
    justify-content: flex-end;
  }

  .total-count {
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 600;
  }

  .history-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 16px;
  }
`

const StyledMemberGdpr = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .section-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
  }

  .section-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .section-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 800;
    color: var(--cms-text-primary);
  }

  .section-copy,
  .permission-note {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    line-height: 1.5;
  }

  .action-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 18px;
  }

  .empty-cell {
    color: var(--cms-text-secondary);
    font-weight: 600;
    text-align: center;
    padding: 18px;
  }
`

export {
  StyledMember,
  StyledMemberDetail,
  StyledMemberSearch,
  StyledMemberSearchBar,
  StyledMemberTable,
  StyledMemberReviews,
  StyledMemberInfo,
  StyledMemberSubscriptions,
  StyledModalMemberPasswordResetDialog,
  StyledMemberHistory,
  StyledMemberGdpr,
}
